import { headerHeightLg } from '@/constants/layouts';
import { GridProps } from '@chakra-ui/react';
import { Grid } from '@cmpsr/components';

export default function MainContentAuth(props: GridProps): React.ReactElement {
  return (
    <Grid
      as="main"
      gridTemplateColumns={{ base: '1fr', lg: '42% 1fr', xl: '1fr 1fr' }}
      gridTemplateRows="1fr"
      height={{ base: '100%', lg: `calc(100svh - ${headerHeightLg})` }}
      {...props}
    />
  );
}
